

import { Controller } from "@hotwired/stimulus"
// Connects to data-controller="redirect-click"
export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.onClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this.onClick)
  }

  onClick(event) {
    event.target.closest('a, button, .popover-menu') == null && event.target.closest('li').querySelector('.--default-action').click()
  }
}